import { jsx, jsxs } from 'react/jsx-runtime';
import { IconCaretDown } from '@belong/icons';
import { Accordion as Accordion$1, AccordionItem, AccordionButton, AccordionPanel } from '@reach/accordion';
import clsx from 'clsx';
import { Divider } from '../Divider/Divider.js';
import { Text } from '../Text/Text.js';

const Accordion = ({
  index,
  items,
  onChange,
  multiple,
  withDivider = true
}) => jsx(Accordion$1, {
  index: index,
  collapsible: true,
  onChange: onChange,
  multiple: multiple,
  children: items.map(({
    content,
    title
  }, itemIndex) => {
    const isSelected = itemIndex === index;
    return jsxs(AccordionItem, {
      className: "group",
      children: [withDivider && itemIndex === 0 && jsx(Divider, {}), jsxs(AccordionButton, {
        className: "flex w-full justify-between py-sm transition-colors duration-hover hover:cursor-pointer group-hover:text-dark-navy",
        children: [jsx(Text, {
          as: "div",
          className: "text-left",
          fontWeight: "semibold",
          children: title
        }), jsx(IconCaretDown, {
          className: clsx('ml-xs transition-transform duration-hover', {
            'rotate-180': isSelected
          }),
          style: {
            width: 16,
            minWidth: 16,
            marginTop: 8
          }
        })]
      }), jsx(AccordionPanel, {
        className: "invisible grid grid-rows-[0fr] transition-[grid-template-rows,visibility] duration-hover ease-in-out motion-reduce:transition-none data-[state=open]:visible data-[state=open]:grid-rows-[1fr]",
        children: jsx("div", {
          className: "overflow-hidden",
          children: jsx("div", {
            className: "pb-sm",
            children: content
          })
        })
      }), withDivider && jsx(Divider, {})]
    }, itemIndex);
  })
});

export { Accordion };
